/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Confirm_Revokes_Project_AccessInputs */



/**
* | output |
* | --- |
* | "The project's members lose access now, and a restore brings it back private." |
*
* @param {Chat_Tool_Confirm_Revokes_Project_AccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_confirm_revokes_project_access = /** @type {((inputs?: Chat_Tool_Confirm_Revokes_Project_AccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Confirm_Revokes_Project_AccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Mitglieder des Projekts verlieren sofort den Zugriff; nach dem Wiederherstellen ist die App privat.")
	return /** @type {LocalizedString} */ ("The project's members lose access now, and a restore brings it back private.")
});